import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

// Public client config — supply the project-specific values via env
// (REACT_APP_FIREBASE_API_KEY, REACT_APP_FIREBASE_APP_ID, ...). The rest
// default to the known ArtSyde project.
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'artsyde-312ed.firebaseapp.com',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'artsyde-312ed',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'artsyde-312ed.appspot.com',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.appId);

let app = null;
function ensureApp() {
    if (!isFirebaseConfigured) return null;
    if (!app) app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
    return app;
}

/** Opens the Google popup and resolves with the Firebase ID token to send to /auth/google. */
export async function signInWithGoogle() {
    const instance = ensureApp();
    if (!instance) {
        throw new Error('Google sign-in is not configured.');
    }
    const auth = getAuth(instance);
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return result.user.getIdToken();
}
